import dynamic from 'next/dynamic'
import { Schemas } from '~/api/gen'
import { Chip } from '~/components/elements/Chip'
import { ShowMoreDescription } from '~/components/modules/ShowMoreDescription/ShowMoreDescription'
import { isCategoryAllowedToDisplayAd } from '~/features/shared/ad/lib/isCategoryAllowedToDisplayAd'
import { spItemDetailAds } from '../data/googleAd'
import { ItemDetailForPc } from './ItemDetailForPc'
import { PurchaseDetail } from './PurchaseDetail'

const GoogleAd = dynamic(
  () => import('~/features/shared/ad/components/GoogleAd'),
  {
    ssr: false,
  }
)

type Props = {
  item: Schemas.item_large
}

/* eslint-disable complexity */
export const ItemInformation: React.FC<Props> = ({ item }) => {
  const displayAd = item.category.child_category.id
    ? isCategoryAllowedToDisplayAd(item.category.child_category.id)
    : true // 子カテゴリーが設定されてなければ広告表示

  return (
    <section className="px-4 pb-6 xl:flex xl:flex-col xl:gap-[18px] xl:p-0">
      <PurchaseDetail item={item} />
      <div className="xl:hidden">
        <h2 className="pt-6 text-[14px] font-bold leading-none">商品説明</h2>
        <ShowMoreDescription
          content={item.content ?? ''}
          className="pt-[11px]"
          rowLength={2}
        />

        {displayAd && (
          <GoogleAd
            elementId={spItemDetailAds.middle}
            className="pb-11 pt-7 empty:pb-0 empty:pt-[19px]"
          />
        )}
        {item?.variations?.sizes && (
          <>
            <h2 className="text-[14px] font-bold leading-none">サイズ展開</h2>
            <p className="pt-4 text-[12px] leading-none">
              {item.variations.sizes.map((size) => size.name).join(', ')}
            </p>
          </>
        )}
        {item.category && (
          <>
            <h2 className="pt-6 text-[14px] font-bold leading-none">
              カテゴリー
            </h2>
            <ul className="flex flex-wrap gap-[6px] pt-4">
              {typeof item.category.id === 'number' && (
                <li>
                  <Chip
                    href={`/item/?brand_id=${item.brand.id}&type_category_id=${item.category.id}`}
                  >
                    {item.category.name}
                  </Chip>
                </li>
              )}
              {typeof item.category.child_category.id === 'number' && (
                <li>
                  <Chip
                    href={`/item/?brand_id=${item.brand.id}&type_category_id=${item.category.id}&category_id=${item.category.child_category.id}`}
                  >
                    {item.category.child_category.name}
                  </Chip>
                </li>
              )}
            </ul>
          </>
        )}
        {item.keywords && item.keywords.length > 0 && (
          <>
            <h2 className="pt-6 text-[14px] font-bold leading-none">
              キーワード
            </h2>
            <ul className="flex flex-wrap gap-[6px] pt-4">
              {item.keywords.map((keyword) => (
                <li key={keyword.id}>
                  <Chip
                    href={`/item/?search_word=${keyword.name}&searchword_flag=1`}
                  >
                    {keyword.name}
                  </Chip>
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
      <div className="hidden xl:block">
        <ItemDetailForPc item={item} />
      </div>
    </section>
  )
}
